export const USE_CANCELLATION = 'useCancellation';
export const USE_MEMBERSHIP_CANCELLATION = 'useMembershipCancellation';
export const IS_ADMIN_SITE_OFFLINE = 'isAdminSiteOffline';
export const USE_BULK_RENEWAL_TAB = 'useBulkRenewalTab';
